import * as React from 'react';
import * as styles from './styles.scss';
import { observer } from 'mobx-react-lite';
import { TextField, ITextField } from '@fluentui/react/lib/TextField';
import { getName, setName } from '../viewstate';
import loc from 'owa-localize';
import { enterNamePlaceholderText } from './BoardEditorStrings.locstring.json';
import { createOrUpdateBoardName } from '../viewstate/utils';

export default observer(function BoardEditorFields() {
    const textFieldRef = React.useRef<ITextField | null>(null);

    React.useEffect(() => {
        textFieldRef.current?.focus();
    }, []);

    return (
        <TextField
            componentRef={textFieldRef}
            styles={{
                fieldGroup: styles.editorTextFieldGroup,
            }}
            placeholder={loc(enterNamePlaceholderText)}
            value={getName()}
            onChange={onTextChange}
            onKeyPress={onKeyPress}
        />
    );
});

function onTextChange(
    ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    newValue?: string
) {
    setName(newValue);
}

function onKeyPress(event) {
    if (event.key === 'Enter') {
        createOrUpdateBoardName();
    }
}
